module.exports = __webpack_public_path__ + "05c88e41fc725cb1974b99534a8f8357.woff";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/OpenSans-Light-webfont.woff
// module id = 2516
// module chunks = 17